import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';
import { eUserType } from '@app/shared/enum/user-type';

@Injectable({
  providedIn: 'root'
})
export class CarrierGuard implements CanActivate {
  constructor(private _localStorageService: LocalStorageService,
    private _router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    const userType = Number(
      this._localStorageService.getValueByKey('userType')
    );

    if (
      userType === eUserType.CARRIER ||
      userType === eUserType.CARRIER_BRANCH_ADMIN ||
      userType === eUserType.DISPATCHERS ||
      userType === eUserType.CARRIER_FINANCIAL_ADMIN
    ) {
      return true
    }

    else {
      this._router.navigate(['account/login']);
      return false
    }
  }
}
